import { render } from "./ProjectReturnForm.vue?vue&type=template&id=66249ee4&scoped=true&ts=true"
import script from "./ProjectReturnForm.ts?vue&type=script&lang=ts"
export * from "./ProjectReturnForm.ts?vue&type=script&lang=ts"

import "./ProjectReturnForm.scss?vue&type=style&index=0&id=66249ee4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66249ee4"]])

export default __exports__